import React from 'react';
import { Reveal } from './Reveal';
import { stats } from '../data/stats';
export function StatsBar() {
  return <section className="border-y border-brand-sand bg-brand-sandSoft py-8" data-id="element-149" data-mp="1tbjghngupucr">
      <Reveal className="mx-auto grid max-w-5xl grid-cols-2 gap-y-8 px-4 text-center md:grid-cols-4 md:gap-8" data-id="element-150" data-mp="1oavrf7c6nnl6">
        {stats.map(([value, label], index) => <div key={label} className={`flex flex-col items-center justify-center ${index > 0 ? 'md:border-l md:border-brand-sand' : ''}`} data-id="element-151" data-mp="1jeeqfcjvxeqo" data-mpi={index}>
            <span className="mb-1 font-serif text-3xl font-bold text-brand-slate md:text-4xl" data-id="element-152" data-mp="19kxy6czec7p4">{value}</span>
            <span className="text-[10px] font-bold uppercase tracking-wider text-brand-gray md:text-xs" data-id="element-153" data-mp="15lfgdq2vgcqi">{label}</span>
          </div>)}
      </Reveal>
    </section>;
}